/**
 * Lentes reales girando en 3D.
 * Usa una foto de producto real y aplica rotación Y con CSS puro.
 */
const GLASSES_FRONT =
  "https://www.lens.cl/cdn/shop/files/p-rx3447v2500-1-f3392300-5619-45f2-8ad6-550437344c83.jpg?v=1735272609&width=1200";
const GLASSES_SIDE =
  "https://www.lens.cl/cdn/shop/files/p-rx3447v2500-2-e0b0a9f6-ebbf-4658-bc46-d9914de6262e.jpg?v=1735272609&width=1200";

export default function SpinningGlasses() {
  return (
    <div
      className="relative w-full aspect-[4/5] flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#FAF9F6] via-[#F0F0EE] to-[#FAF9F6]"
      data-testid="spinning-glasses"
      style={{ perspective: "1400px" }}
    >
      {/* halo dorado */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[70%] aspect-square rounded-full bg-gradient-to-br from-[#E9C46A]/30 via-transparent to-[#B8933A]/10 blur-3xl" />
      </div>

      {/* anillos rotando */}
      <div className="absolute w-[82%] aspect-square rounded-full border border-[#E9C46A]/35 animate-[spin_40s_linear_infinite]" />
      <div className="absolute w-[62%] aspect-square rounded-full border border-[#B8933A]/45 animate-[spin_60s_linear_infinite_reverse]" />

      {/* contenedor 3D con flip entre frontal y lateral */}
      <div
        className="relative z-10 w-[72%] max-w-[440px] aspect-[4/3]"
        style={{ transformStyle: "preserve-3d", animation: "glasses-flip 8s cubic-bezier(0.4,0,0.2,1) infinite, glasses-float 6s ease-in-out infinite" }}
      >
        <img
          src={GLASSES_FRONT}
          alt="Lentes ópticos vista frontal"
          className="absolute inset-0 w-full h-full object-contain drop-shadow-[0_25px_35px_rgba(0,0,0,0.25)]"
          style={{ backfaceVisibility: "hidden" }}
          loading="eager"
        />
        <img
          src={GLASSES_SIDE}
          alt="Lentes ópticos vista lateral"
          className="absolute inset-0 w-full h-full object-contain drop-shadow-[0_25px_35px_rgba(0,0,0,0.25)]"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
          loading="eager"
        />
      </div>

      <style>{`
        @keyframes glasses-flip {
          0%   { transform: rotateY(0deg); }
          45%  { transform: rotateY(180deg); }
          55%  { transform: rotateY(180deg); }
          100% { transform: rotateY(360deg); }
        }
        @keyframes glasses-float {
          0%, 100% { translate: 0 0; }
          50%      { translate: 0 -18px; }
        }
      `}</style>
    </div>
  );
}
